import { useState, useEffect } from "react";

export const useTimer = () => {
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => prev + 1); // Force re-render every second
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return timer; // Return the timer value
};
